// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"279":"locale-ar","840":"locale-my"}[chunkId] || chunkId) + "." + {"279":"73691991","453":"3ac21760","840":"41a06976"}[chunkId] + ".chunk.js";
};